class RepairFormHandler {
  constructor(wrapperId) {
	this.wrapper = document.getElementById(wrapperId);
	this.serialContainer = this.wrapper.querySelector('.serial-number-container');
	this.addButton = this.serialContainer.querySelector('.add-serial');
	this.submitButton = this.wrapper.querySelector('#submit-button');

	this.api = new CustomerPortalAPI();

	this.addListeners();
  }

  addListeners() {
	this.addButton.addEventListener('click', this.addSerialField.bind(this));
	this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
  }

  addSerialField() {
	const newField = document.createElement('div');
	newField.className = 'serial-number-field';
	newField.innerHTML = `
	  <input type="text" class="field__input" name="serial_numbers[]" placeholder="Enter serial number" required />
	  <label class="field__label">Enter serial number</label>
	  <span class="remove-serial">✕</span>
	`;
	this.serialContainer.insertBefore(newField, this.addButton);
	const removeBtn = newField.querySelector('.remove-serial');
	removeBtn.style.display = 'block';
	removeBtn.addEventListener('click', () => newField.remove());
  }

  collectFormData() {
	const getVal = id => this.wrapper.querySelector(`#${id}`)?.value.trim();
	const getChecked = id => this.wrapper.querySelector(`#${id}`)?.checked;

	const serialNumbers = Array.from(
	  this.wrapper.querySelectorAll('input[name="serial_numbers[]"]')
	).map(el => el.value.trim()).filter(Boolean);

	return {
	  customer_id: window.FMCustomer?.id || '',
	  name: getVal('name'),
	  email: getVal('email'),
	  phone: getVal('phone'),
	  address: getVal('address'),
	  city: getVal('city'),
	  province: getVal('province'),
	  postal_code: getVal('postal_code'),
	  message: getVal('message'),
	  pickup_requested: getChecked('pickup_requested') ? 'yes' : '',
	  serial_numbers: serialNumbers
	};
  }

  async handleSubmit() {
	const data = this.collectFormData();
	const missing = [];
	const fieldLabels = {
	  name: 'Full Name',
	  email: 'Email Address',
	  phone: 'Phone Number',
	  address: 'Address',
	  city: 'Town/City',
	  province: 'Province',
	  postal_code: 'Postal Code',
	  message: 'Problem Description',
	  serial_numbers: 'Serial Numbers'
	};
  
	// Clear previous errors
	this.wrapper.querySelectorAll('.field__input').forEach(input => {
	  input.classList.remove('field--error');
	});
  
	for (const [key, value] of Object.entries(data)) {
	  if (key === 'pickup_requested') continue; // Not required
  
	  if (Array.isArray(value)) {
		if (!value.length) {
		  missing.push(fieldLabels[key] || key);
		  this.markFieldGroupError('serial_numbers[]');
		}
	  } else if (!value) {
		missing.push(fieldLabels[key] || key);
		this.markFieldError(key);
	  }
	}
  
	// Extra validation: email and phone format
	const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email);
	const phoneValid = /^[\d\-\+\s\(\)]+$/.test(data.phone);
  
	if (data.email && !emailValid) {
	  missing.push('Valid Email Address');
	  this.markFieldError('email');
	}
  
	if (data.phone && !phoneValid) {
	  missing.push('Valid Phone Number');
	  this.markFieldError('phone');
	}
  
	if (missing.length) {
	  alert(`Please correct the following:\n\n- ${missing.join('\n- ')}`);
	  return;
	}
  
	const result = await this.api.postRepairForm(data);
  
	if (result.ok) {
	  // Hide form intro
		const intro = document.querySelector('.rich-text, .section-intro');
		if (intro) intro.remove();
	  
		// Replace form with success message and reset button
		this.wrapper.innerHTML = `
		  <div class="success">
			<h2>✅ Submission Successful</h2>
			<p>Thank you! Your repair request has been submitted successfully.</p>
			<button class="button" id="reset-form">Submit Another Request</button>
		  </div>
		`;
	  
		// Add listener to reset the form by reloading the page
		document.getElementById('reset-form').addEventListener('click', () => {
		  location.reload();
		});
		
	} else {
	  this.wrapper.innerHTML = `
		<div class="error">
		  <h2>❌ Something Went Wrong</h2>
		  <p>We're sorry, but your repair request could not be submitted at this time. Please try again later.</p>
		  <button class="button" id="retry-form">Try Again</button>
		</div>
	  `;
	  
	  // Add listener to reload the page
	  document.getElementById('retry-form').addEventListener('click', () => {
		location.reload();
	  });
	}
  }
  
  markFieldError(id) {
	const field = this.wrapper.querySelector(`#${id}`);
	if (field) field.classList.add('field--error');
  }
  
  markFieldGroupError(name) {
	this.wrapper.querySelectorAll(`input[name="${name}"]`).forEach(input => {
	  if (!input.value.trim()) {
		input.classList.add('field--error');
	  }
	});
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RepairFormHandler('repair-form-wrapper');
});